<template>
  <v-row no-gutters class="flex-nowrap">
    <v-menu
      ref="datePicker"
      :close-on-content-click="false"
      v-model="dateDialog"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="readonly"
    >
      <template #activator="{on}">
        <v-text-field
          :prependIcon="prependIcon"
          :prependInnerIcon="prependInnerIcon"
          :rules="rules"
          v-on="on"
          v-model="contextModel"
          :label="label"
          prepend-icon=""
          :error-messages="dateValidation"
          readonly
          :placeholder="placeholder"
          :clearable="clearable"
        />
      </template>
      <v-date-picker v-model="date" no-title scrollable :locale="locale" :max="max" :min="min" first-day-of-week="1" @input="$refs.datePicker.save(date)">
      </v-date-picker>
    </v-menu>
    <span v-if="defaultButton && readonly === false" class="pt-4">
      <v-tooltip :disabled="buttonTooltip == null" bottom>
        <template #activator="{on}">
          <v-btn :disabled="buttonDisabled" @click="setDefaultValue" text icon v-on="on">
            <v-icon>{{ buttonIcon }}</v-icon>
          </v-btn>
        </template>
        {{ buttonTooltip }}
      </v-tooltip>
    </span>
  </v-row>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    rules: {
      required: false,
      default: () => []
    },
    readonly: {
      required: false,
      default: false
    },
    model: {
      required: true
    },
    label: {
      required: false,
      default: null
    },
    dateValidation: {
      type: Array,
      required: false,
      default: () => []
    },
    placeholder: {
      default: null,
      type: String
    },
    min: {
      default: null,
      type: String,
      required: false
    },
    max: {
      default: null,
      type: String,
      required: false
    },
    dialog: {
      default: null,
      required: false
    },
    defaultButton: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultValue: {
      required: false
    },
    buttonTooltip: {
      default: null
    },
    buttonIcon: {
      default: "keyboard_return"
    },
    buttonDisabled: {
      default: false
    },
    clearable: {
      default: false
    },
    prependInnerIcon: {
      default: null
    },
    prependIcon: {
      default: null
    }
  },
  data: () => ({
    dateDialog: false
  }),
  methods: {
    setDefaultValue() {
      this.date = this.defaultValue;
    }
  },
  computed: {
    contextModel: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit("update:model", val);
      }
    },
    contextLabel() {
      if (this.label === false) {
        return this.$t("global.date");
      }
      return this.label;
    },
    date: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    },
    contextDialog: {
      set(value) {
        if (this.dialog == null) {
          this.dateDialog = value;
        } else {
          this.$emit("update:dialog", value);
        }
      },
      get() {
        if (this.dialog != null) return this.dialog;
        return this.dateDialog;
      }
    },
    locale() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style scoped></style>
